<template>
	<div class="statistica__calendar">
		<div class = "statistica__calendar-row-title">
			<div class ="statistica__calendar-row-title-item" v-for="(items,index) in titles" :key="index + 'tl'">{{items}}</div>
		</div>
		<div v-for="(years, index) in years" :key="index">

			<!-- <div class="statistica__calendar-row-item"
				 v-for = "(data, key) in takeYear" :key="key">{{data.profit}}</div>-->
			<string :year="years"></string>
		</div>
	</div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from "vuex";
import ProfitString from './sig-profit-string'
export default {
    components : {
        'string':ProfitString
    },
    data() {
        return {
            titles : {
                year: 'год',
                jan: 'янв',
                feb: 'фев',
                mar: 'мрт',
                apr: 'апр',
                may: 'май',
                jun: 'июн',
                jul: 'июл',
                aug: 'авг',
                sep: 'сен',
                oct: 'окт',
                nov: 'ноя',
                dec: 'дек',
                all: 'итог'
            },

            stat: [],
            symbol:'',
            years:[]
        }
    },
    computed : {
        ...mapGetters({
            getProfit:'accountstat/getMonthProfitStrategy'
        })
    },
    methods: {
        getYears() {
            let stat = this.getProfit('');
            if (!stat) return false;
            this.years = getYear(stat);
        }
    },
    created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
            if (!this.symbol || !this.symbol.length) {
                let stat = this.getProfit(this.symbol);
                 this.stat = stat
                 this.getYears();
            }
        });
        this.getYears();
    }
}
function getYear(stat) {
    let allYears = {};
            for(let i =0; i < stat.length; i++)
            {
                let key = stat[i].year;
                allYears[key] = true;
            }
            let years = [];
            return Object.keys(allYears);
}

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "statistic-profit",
            handler: handler
        }
    });
}
</script>
<style lang="less" scoped>
.statistica__calendar {
    background: #3d536b;
    &-row-title {
        display: flex;
        justify-content: space-between;

        &-item {
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.64;
            letter-spacing: 0.4px;
            text-align: right;
            text-transform: uppercase;
            color: #adc7e1;
            width: 66px;
            flex-grow: 1;
            padding-right: 12px;
            box-sizing: border-box;

            &:first-child {
                font-family: Arimo;
                font-size: 11px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 3.64;
                letter-spacing: 0.4px;
                text-align: right;
                text-transform: uppercase;
                color: #adc7e1;
                width: 66px;
                flex-grow: 1;
                padding-right: 12px;
                box-sizing: border-box;
            }
        }
    }
    &-row {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #324258;
        &-item {
            font-family: Arimo;
            font-size: 13px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 2.15;
            letter-spacing: 0.4px;
            text-align: right;
            color: @colors[green];
            width: 66px;
            flex-grow: 1;
            padding-right: 12px;
            box-sizing: border-box;
        }
    }
}
</style>

